import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDown1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;fill-rule:evenodd;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "arrow-down-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M23.25,7.311,12.53,18.03a.749.749,0,0,1-1.06,0L.75,7.311"
		})
	]
});
export { SvgArrowDown1 as ReactComponent };
